/**
 * DnD Context
 * Drag and drop context for React Flow node creation
 */

import React, { createContext, useContext, useState, ReactNode } from "react";
import { MindMapNodeType } from "./mindMapTypes";

type DnDContextType = [
  MindMapNodeType | null,
  React.Dispatch<React.SetStateAction<MindMapNodeType | null>>,
];

const DnDContext = createContext<DnDContextType>([null, () => {}]);

export const DnDProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [type, setType] = useState<MindMapNodeType | null>(null);

  return (
    <DnDContext.Provider value={[type, setType]}>
      {children}
    </DnDContext.Provider>
  );
};

export const useDnD = (): DnDContextType => {
  return useContext(DnDContext);
};

export default DnDContext;
